import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {
  error: string
} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  error: '',
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.SUBMIT_REPLY_FOR_LABORER_E_TO_I_REQUEST_ASYNC,
    Actions.SUBMIT_REPLY_FOR_LABORER_E_TO_I_REQUEST_SUCCESS,
    Actions.SUBMIT_REPLY_FOR_LABORER_E_TO_I_REQUEST_FAIL,
    {},
    {
      error: string
    }
  >,
): State => {
  switch (action.type) {
    case Actions.SUBMIT_REPLY_FOR_LABORER_E_TO_I_REQUEST_ASYNC:
    case Actions.SUBMIT_REPLY_FOR_LABORER_E_TO_I_REQUEST_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.SUBMIT_REPLY_FOR_LABORER_E_TO_I_REQUEST_FAIL: {
      return {
        ...state,
        ...action.status,
        error: action.payload?.error || '',
      }
    }
    default:
      return state
  }
}
